document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sticky-atc').forEach((bar) => {
    const targetId = bar.dataset.observeTarget;
    const target = targetId && document.getElementById(targetId);
    if (!target) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          bar.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );

    observer.observe(target);
  });
});
